import { render, staticRenderFns } from "./WatchVote.vue?vue&type=template&id=27080ef7"
import script from "./WatchVote.vue?vue&type=script&lang=js"
export * from "./WatchVote.vue?vue&type=script&lang=js"
import style0 from "./WatchVote.vue?vue&type=style&index=0&id=27080ef7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports